import { render, staticRenderFns } from "./file-uploader-ctrl.vue?vue&type=template&id=567be2fa&scoped=true"
import script from "./file-uploader-ctrl.vue?vue&type=script&lang=js"
export * from "./file-uploader-ctrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567be2fa",
  null
  
)

export default component.exports